export default {
    ca: {
        toolsSection: {
            title: 'Elements del mapa',
            items: {
                legend: 'Llegenda',
                legendPrint: 'Capturar llegenda',
                layers: 'Capes',
                backgrounds: 'Fons',
                export: {
                    title: 'Exportar',
                    image: 'Capturar la vista del mapa',
                    print: 'Imprimir la vista del mapa',
                    geoPdf: 'Format GeoPDF',
                    geoTiff: 'Format GeoTIFF',
                    geoPackage: 'Format GeoPackage',
                    printEscala: 'Imprimir mapa a escala',
                    descCapes: 'Descarregar una capa',
                    loaderTitle: 'Exportant',
                    loaderMessage: 'S\'està exportant el mapa com a',
                    errorTitle: 'Error en l\'exportació',
                    errorMessage: 'S\'ha produit un error durant el procés d\'exportació',
                },
                share: 'Compartir',
                view3D: 'Vista 2D/3D',
            },
        },
        searchSection: {
            title: 'Cercador',
            placeholder: 'Escriu aquí...',
            noresults: 'No hi ha resultats',
        },
    },
    es: {
        toolsSection: {
            title: 'Herramientas del mapa',
            items: {
                legend: 'Leyenda',
                legendPrint: 'Capturar leyenda',
                layers: 'Capas',
                backgrounds: 'Fondos',
                export: {
                    title: 'Exportar',
                    image: 'Capturar la vista del mapa',
                    print: 'Imprimir la vista del mapa',
                    geoPdf: 'Formato GeoPDF',
                    geoTiff: 'Formato GeoTIFF',
                    geoPackage: 'Formato GeoPackage',
                    printEscala: 'Imrpimir mapa a escala',
                    descCapes: 'Descargar una capa',
                    loaderTitle: 'Exportando',
                    loaderMessage: 'Se está exportando el mapa como',
                    errorTitle: 'Error en la exportación',
                    errorMessage: 'Se ha producido un error durante el proceso de exportación',
                },
                share: 'Compartir',
                view3D: 'Vista 2D/3D',
            },
        },
        searchSection: {
            title: 'Buscador',
            placeholder: 'Escribe aquí...',
            noresults: 'No hay resultados',
        },
    },
    en: {
        toolsSection: {
            title: 'Map tools',
            items: {
                legend: 'Legend',
                legendPrint: 'Capture legend',
                layers: 'Layers',
                backgrounds: 'Backgrounds',
                export: {
                    title: 'Export',
                    image: 'Capture the map view',
                    print: 'Print map view',
                    geoPdf: 'GeoPDF Format',
                    geoTiff: 'GeoTIFF Format',
                    geoPackage: 'GeoPackage Format',
                    printEscala: 'Print scale map',
                    descCapes: 'Download layer',
                    loaderTitle: 'Exporting',
                    loaderMessage: 'The map is being exported as',
                    errorTitle: 'Export error',
                    errorMessage: 'An error occurred during the export process',
                },
                share: 'Share',
                view3D: 'Switch 2D/3D',
            },
        },
        searchSection: {
            title: 'Search',
            placeholder: 'Type here...',
            noresults: 'Not results found',
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/floating-sidemenu/floating-sidemenu-translations.js